import { isBrowser } from 'src/utils/platform';
const E2E_PERSONAS = new Set(['admin', 'user', 'guest']);
function detectE2E() {
    if (!__DEV__ || !isBrowser || typeof window === 'undefined') {
        return false;
    }
    try {
        const persona = new URLSearchParams(window.location.search).get('e2ePersona');
        return persona != null && E2E_PERSONAS.has(persona);
    }
    catch {
        return false;
    }
}
/**
 * True when dev web was opened with `?e2ePersona=`. Captured once at load,
 * same as `isSeoCrawler`, so later navigations can drop the query.
 */
export const isE2E = detectE2E();
